import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangas';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-flower-fill text-lg"></i>
              </span>
              <span className="font-heading text-2xl font-bold text-primary-600">樱花漫画</span>
            </Link>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              樱花漫画网专注日漫阅读，聚合少女漫画、唯美漫画、校园恋爱与耽美漫画，热门日漫新番同步更新，分类清晰，点开即读。
            </p>
            <div className="mt-4 flex items-center gap-3 text-foreground-500">
              <a href="#" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 transition hover:bg-primary-500 hover:text-background-50">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" aria-label="微信" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 transition hover:bg-primary-500 hover:text-background-50">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 transition hover:bg-primary-500 hover:text-background-50">
                <i className="ri-bilibili-fill text-base"></i>
              </a>
            </div>
          </div>

          {/* Categories */}
          <nav aria-label="热门分类">
            <h4 className="font-heading text-base font-semibold text-foreground-900">热门分类</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/category/${c.slug}`} className="transition hover:text-primary-600">
                    {c.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/category/new" className="transition hover:text-primary-600">
                  日漫新番
                </Link>
              </li>
            </ul>
          </nav>

          {/* Site */}
          <nav aria-label="站内导航">
            <h4 className="font-heading text-base font-semibold text-foreground-900">站内导航</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li><Link to="/" className="transition hover:text-primary-600">网站首页</Link></li>
              <li><Link to="/category/all" className="transition hover:text-primary-600">全部漫画</Link></li>
              <li><Link to="/about" className="transition hover:text-primary-600">关于我们</Link></li>
              <li><Link to="/contact" className="transition hover:text-primary-600">联系我们</Link></li>
              <li><Link to="/about" className="transition hover:text-primary-600">追更指南</Link></li>
            </ul>
          </nav>

          {/* Notice */}
          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900">阅读提示</h4>
            <p className="mt-4 text-sm leading-6 text-foreground-600">
              本站漫画仅供个人学习与阅读参考，请支持正版。若内容涉及版权问题，请联系我们处理。
            </p>
            <p className="mt-3 text-sm text-foreground-600">
              问题反馈：<a href="mailto:support@sakuramanga.example.com" className="text-primary-600 underline-offset-2 hover:underline">support@sakuramanga.example.com</a>
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {year} 樱花漫画网 SakuraManga · 以阅读之名，遇见更多心动。</p>
          <p>樱花漫画网 · 日漫阅读在线追更平台</p>
        </div>
      </div>
    </footer>
  );
}